

const navigateStripe = () => {
    window.location.href = "https://portal.strapi.net/b/3cs9DN9XA4oj7aodQS"; // Replace with your actual trial signup link
};

module.exports = {
    navigateStripe
}